import React from 'react';
// import Partners from '../../../pages/people-partners/Partners';
import Partners from './Partners';
import Educators from '../../../pages/educators/Educators';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useMissingFields from '../../project_manage/useMissingFields';
import EmptyState from '../../_common/EmptyState';
import Results from '../../../pages/_common_results/Results';
import User from '../../../pages/_common_user/ManageUser';
import Filters from '../../../forms/filters_educators';
import { AcademicCapIcon, FolderIcon, UsersIcon } from '@heroicons/react/24/outline';
import { useConnect } from '@lore/query-connect';
import useRouter from '../../../hooks/useRouter';
import classNames from 'classnames';
import PaginationInformation from '../../../components/pagination-new/PaginationInformation';
import SortBy from '../../../pages/educators/SortBy';
import FilterButton from '../../../pages/_common_filters/FilterButton';
import useDialogConfig from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import useDialogRouter from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogRouter';

export default function Layout(props) {
  const { site } = props;

  const { id, route } = useDialogConfig();
  const router = useDialogRouter(id);

  return (
    <div className="space-y-8">
      {/*<Filters router={router} />*/}
      <Partners router={router} site={site}>
        {function(result) {
          return (
            <Results result={result} resource="partners" emptyIcon={UsersIcon}>
              {function(user, index) {
                return (
                  <User
                    key={index}
                    user={user}
                  />
                );
              }}
            </Results>
          );
        }}
      </Partners>
    </div>
  );
};
